import React from 'react';
import { ASSETS } from '../data/assets';
import styles from './AssetRow.module.css';

const TODAY = new Date().toISOString().split('T')[0];

const CAT_CLASS = {
  MHE:         styles.catMHE,
  Charger:     styles.catCharger,
  Battery:     styles.catBattery,
  Accessories: styles.catAccessories,
};

export default function AssetRow({ row, index, onHours, onDate, onToggleNA }) {
  const asset = ASSETS[row.id];
  const isDone = !row.na && row.hours !== '' && row.date !== '';

  let rowClass = styles.row;
  if (row.na)    rowClass += ' ' + styles.rowNA;
  else if (isDone) rowClass += ' ' + styles.rowDone;

  let numClass = styles.rowNum;
  if (row.na)    numClass += ' ' + styles.numNA;
  else if (isDone) numClass += ' ' + styles.numDone;

  return (
    <div className={rowClass}>

      {/* # */}
      <div className={styles.numCell}>
        <div className={numClass}>
          {row.na ? '—' : isDone ? '✓' : index + 1}
        </div>
      </div>

      {/* Asset info */}
      <div className={styles.infoCell}>
        <span className={styles.model}>{asset.model}</span>
        <span className={styles.serial}>{asset.serial}</span>
        <span className={`${styles.catBadge} ${CAT_CLASS[asset.category]}`}>
          {asset.category}
        </span>
      </div>

      {/* Hours input */}
      <div className={styles.inputCell}>
        <input
          className={`${styles.input} ${row.hours && !row.na ? styles.inputFilled : ''}`}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="e.g. 4575"
          value={row.hours}
          disabled={row.na}
          onChange={e => onHours(row.id, e.target.value)}
        />
      </div>

      {/* Date input */}
      <div className={styles.inputCell}>
        <input
          className={`${styles.input} ${styles.dateInput} ${row.date && !row.na ? styles.inputFilled : ''}`}
          type="date"
          value={row.date}
          max={TODAY}
          disabled={row.na}
          onChange={e => onDate(row.id, e.target.value)}
        />
      </div>

      {/* N/A toggle */}
      <div className={styles.toggleCell}>
        <label className={styles.toggle}>
          <div
            className={`${styles.track} ${row.na ? styles.trackOn : ''}`}
            onClick={() => onToggleNA(row.id)}
          >
            <div className={styles.thumb} />
          </div>
          <span className={`${styles.toggleLabel} ${row.na ? styles.toggleLabelOn : ''}`}>
            {row.na ? 'On' : 'Off'}
          </span>
        </label>
      </div>

    </div>
  );
}
